import { render, staticRenderFns } from "./AddOrUpdateSpaceStation.vue?vue&type=template&id=4bddc7fb&scoped=true"
import script from "./AddOrUpdateSpaceStation.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateSpaceStation.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateSpaceStation.vue?vue&type=style&index=0&id=4bddc7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bddc7fb",
  null
  
)

export default component.exports